import * as React from "react"
import { Box } from "@mui/material"

import { DateRangeBlock } from "@components"
import { DATE_PERIODS } from "@constants"
import { PricingMarketAnalyzerDateRange } from "./Ranges"
import { marketAnalyzerCurrentPeriod } from "../../@signals"


export default function PricingMarketAnalyzerOffersEvolutionChartToolbar({dateRange, onChange, handleClick}) {
    return <Box display="flex" gap={2} alignItems="center">
        <DateRangeBlock
            currentPeriodLabel={marketAnalyzerCurrentPeriod.value}
            maxDays={30}
            value={dateRange}
            ranges={PricingMarketAnalyzerDateRange}
            onChange={onChange}
            onOk={() => marketAnalyzerCurrentPeriod.value = DATE_PERIODS.CUSTOM}
        />
    </Box>
}